export const ActionTypes = {
  LOADING: "UpdateTutorial_USER_LOADING",
  ERROR: "UpdateTutorial_USER_ERROR",
  SUCCESS: "UpdateTutorial_USER_SUCCESS",
};
